// in viewport detector
jQuery(document).ready(function($) {
  var elements = $('[data-detectviewport="1"]');

  var checkElementsInViewport = function() {
    elements.each(function(i, el) {
      if (isElementInViewport(el)) {
        $(el).addClass('in-viewport');
      } else {
        $(el).removeClass('in-viewport');
      }
    });
  };

  $(window).on('scroll resize faux-resize.viewport-detector', function() {
    window.requestAnimFrame(checkElementsInViewport);
  }).trigger('faux-resize.viewport-detector');
});


// nav toggler
jQuery(document).ready(function($) {
  $('.js-toggleNavigation').on('click', function(){
    $('body').toggleClass('alt-menu-is-visible');
    return false;
  });
});


// read more
jQuery(document).ready(function($){
  var readMoreWrapper = $('.readMoreBlock');

  if (!readMoreWrapper.length) {
    return;
  }

  readMoreWrapper.each(function(i, readMoreButton){
    var wrapper = $('<div class="readMoreContent__toggle" />').insertAfter(readMoreButton);
    var labels = $(readMoreButton).text().split('|');
    if (labels.length !== 2) {
      return;
    }

    var readMore = $('<span class="readMoreContent__toggle--readMore" />').text(labels[0]);
    var readLess = $('<span class="readMoreContent__toggle--readLess" />').text(labels[1]);

    readMore.add(readLess)
      .addClass('btn btn-primary btn-lg-hpad')
      .on('click', function(){
        wrapper.toggleClass('is-toggled');
        readMore.add(readLess).toggleClass('is-toggled');
        return false;
      });


    $(readMoreButton).nextAll().appendTo(wrapper);
    readLess.appendTo(wrapper);
    readMore.insertBefore(wrapper);

    readMoreButton.remove();
  });
});


// video popup
jQuery(document).ready(function($) {
  $('.js-openVideoPopup').magnificPopup({
    disableOn: 0,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: true,
    fixedContentPos: true,
  });
});


// affix & table of contents
jQuery(document).ready(function($){
  // table of content
  var BOOTSTRAP_PADDING = 15;
  var affixContainer = $('.js-tocAffix');

  if (!affixContainer.length) {
    return;
  }

  var affixParent = affixContainer.parent();
  var affixWrapper = affixParent.parent().parent()
  var header = $('.siteHeader');
  var wpAdminBar = $('#wpadminbar');
  var fullWidthGallery = $('.fullWidthContent:first');

  var affixParentPosition;
  var updateAffix = function(){
    affixParentPosition = affixParent.offset().top - header.height();
  };


  var isAffix = false;
  var checkAffixPosition = function(){
    var scrollPos = $(window).scrollTop();

    var wpAdminBarHeight = wpAdminBar ? wpAdminBar.height() : 0;

    if (scrollPos > affixParentPosition) {
      if(!isAffix) {
        affixContainer.addClass('affix');
      }

      var wrapperBottomPosition = affixWrapper.offset().top + affixWrapper.innerHeight();

      if (1 || scrollPos + $(this).height() < wrapperBottomPosition) { //  TODO: fix scrolling past container
        affixContainer.css({
          top: (scrollPos - affixParentPosition)
        });
      }

      isAffix = true;
    } else {
      if (isAffix) {
        affixContainer.css({
          top:0
        });
        affixContainer.removeClass('affix');
        isAffix = false;
      }
    }
  };

  $(window).on('resize faux-resize.updateAffix', function() {
    window.requestAnimFrame(updateAffix);
  }).trigger('faux-resize.updateAffix');

  $(window).on('scroll faux-scroll.checkAffixPosition', function() {
    window.requestAnimFrame(checkAffixPosition);
  }).trigger('faux-scroll.checkAffixPosition');

  var lastId,
      topMenuHeight = affixContainer.outerHeight(),
      menuItems = affixContainer.find("a");

  var scrollItems = menuItems.map(function(){
    var hrefAttr = $(this).attr("href");

    if (hrefAttr.indexOf('#') !== 0) {
      return ;
    }
    var item = $(hrefAttr);
    if (item.length) { return item; }
  });

  menuItems.on('click', function(){
    var hrefAttr = $(this).attr('href');
    if (hrefAttr.indexOf('#') === 0) {
      $('body, html').animate({
        scrollTop: $(hrefAttr).offset().top
      });

      return false;
    }
  });

  var updateMenuIndicator = function(){
    // Get container scroll position
       var fromTop = $(this).scrollTop() + topMenuHeight;

       // Get id of current scroll item
       var cur = scrollItems.map(function(){
         if ($(this).offset().top < fromTop) {
           return this;
         }
       });
       // Get the id of the current element
       cur = cur[cur.length-1];
       var id = cur && cur.length ? cur[0].id : "";
       var isAtTheEndOfThePage = $(this).scrollTop() + $(this).height() >= $(document).height() + 300 ;
       var activeClass = 'is-active';

       if (lastId !== id && !isAtTheEndOfThePage) {
           lastId = id;
           menuItems.parent().removeClass(activeClass);

           // if (fromTop) {}

           menuItems.filter("[href='#" + id + "']").parent().addClass(activeClass);
       }

       if (isAtTheEndOfThePage) {
         menuItems.parent().removeClass(activeClass);
         menuItems.last().parent().addClass(activeClass);
       }
  };

  $(window).on('scroll faux-scroll.menu-indicator', function() {
    window.requestAnimFrame(updateMenuIndicator);
  }).trigger('faux-scroll.menu-indicator');
});



jQuery(document).ready(function($){
  $('.toggleAuthRegisterForm').on('change faux-change', 'input', function(e){
    $('.toggleAuthRegisterForm .radio').show();
    $(this).closest('.radio').hide();
    $(e.delegateTarget).attr('data-current-form', this.value);
  });

  $('.toggleAuthRegisterForm :checked').trigger('faux-change');
});


jQuery(document).ready(function($){
  $('.js-showAgreement').on('click', function(){
    var modal = $('.modalPopup-agreement');
    modal.find('.js-modalDownload').attr('href', this.href);

    try{
      ga('send', 'event', 'Download Attachment', 'Before ToS', this.href);
    }catch(err){}

    modal.fadeIn();
    return false;
  });

  $('.modalPopup-agreement .js-modalDownload').on('click', function(){
    try{
      ga('send', 'event', 'Download Attachment', 'ToS Agreed', this.href);
    }catch(err){}
  });

  $('.js-modalDownload').on('click', function(e){
    window.setTimeout( function(){
      $(e.currentTarget).closest('.modalPopup').fadeOut();
    }, 1000 );
  });

  $('.modalPopup-agreement .js-closeModal').on('click', function(){
    $(this).closest('.modalPopup').fadeOut();
    return false;
  });
});